<div class="container-loading">
  <div class="container-icons">
    <div class="bounce1" [ngClass]="{ bounceColor: userType !== 'user' }"></div>
    <div class="bounce2" [ngClass]="{ bounceColor: userType !== 'user' }"></div>
  </div>
  <h3 *ngIf="map">Cargando mapa...</h3>
</div>
